import { render, staticRenderFns } from "./TeacherLayout.vue?vue&type=template&id=8b82e2ec&scoped=true&lang=pug&"
import script from "./TeacherLayout.vue?vue&type=script&lang=ts&"
export * from "./TeacherLayout.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherLayout.vue?vue&type=style&index=0&id=8b82e2ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b82e2ec",
  null
  
)

export default component.exports